import get from "lodash/get";
import { EVBASIC_TOKEN_KEY, EVCORE_TOKEN_KEY } from "@/constants/repositories";
import { getStoredLanguage } from "@/utils/language";
import { getRealmToken, hasToken } from "@/utils/repositories";

/**
 * Synchronous version of BaseRepositoryV2.getAuthHeaders().
 * Required for use in beforeunload handlers, which cannot use async React context.
 * Returns null if no valid auth token is found (e.g. logged out, token expired).
 */
export function buildAuthHeaders(): Record<string, string> | null {
  if (typeof window === "undefined") {
    return null;
  }

  const evbasicToken = localStorage.getItem(EVBASIC_TOKEN_KEY);
  const evcoreToken = localStorage.getItem(EVCORE_TOKEN_KEY);
  if (!hasToken({ evbasicToken, evcoreToken })) {
    return null;
  }

  const persistedBoundStore = localStorage.getItem("persisted-bound-store");
  const realm = get(JSON.parse(persistedBoundStore || "{}"), "state.realm");
  const realmToken = getRealmToken({ evbasicToken, evcoreToken, realm });
  const realmAccessToken = get(JSON.parse(realmToken || "{}"), "access_token");
  if (!realmAccessToken) {
    return null;
  }

  const lng = getStoredLanguage();

  return {
    "Content-Type": "application/json",
    Accept: "application/json; charset=utf-8",
    "Accept-Language": lng,
    Authorization: `Bearer ${realmAccessToken}`,
    "x-provider-realm": realm ?? "",
    Realm: realm ?? "",
  };
}
